import { BodyText, InlineLink } from '@utilitywarehouse/hearth-react';

import { EXTERNAL_LINKS } from '@constants/externalLinks';

import './styles.scss';

interface MobilePromoNoteProps {
  showTransferPromoText?: boolean;
  showEuRoamingText?: boolean;
}

const MobilePromoNote = ({
  showTransferPromoText = true,
  showEuRoamingText = false,
}: MobilePromoNoteProps) => {
  if (!showTransferPromoText && !showEuRoamingText) {
    return null;
  }

  return (
    <BodyText className="mobilePromoNote" size="sm" color="secondary">
      {showTransferPromoText && (
        <>
          * Transfer of existing number required. This promotion is available to
          new UW mobile customers only who transfer an existing mobile number to
          UW and keep the transferred number with UW for the duration of the
          promotional period.{' '}
          <InlineLink
            href={EXTERNAL_LINKS.termsMobileSection}
            rel="noreferrer noopener"
            target="_blank"
            hideOpenIcon
          >
            Terms Apply.
          </InlineLink>{' '}
        </>
      )}
      {showEuRoamingText && (
        <>
          EU Roaming with Go Unlimited, subject to 14GB roaming cap. Data
          consumption subject to 500GB personal usage cap. EU roaming with Go
          Essential plan, subject to 10GB data allowance. See{' '}
          <InlineLink
            href={EXTERNAL_LINKS.termsMobileSection}
            rel="noreferrer noopener"
            target="_blank"
            hideOpenIcon
          >
            terms
          </InlineLink>{' '}
          &{' '}
          <InlineLink
            href={EXTERNAL_LINKS.mobileFairUsePolicy}
            rel="noreferrer noopener"
            target="_blank"
            hideOpenIcon
          >
            fair use policy
          </InlineLink>
          .
        </>
      )}
    </BodyText>
  );
};

export { MobilePromoNote };
